<template>
  <div class="slide-header colorSlider">
    <div class="avatarFrame">
      <div
        class="avatarMobile"
        :style="{ 'background-image': ImageUrl }"
        @click="$router.push('/change-picture-request')"
      ></div>
    </div>
    <div class="nameMobile">
      <template v-if="userActive">
        <div style="font-size: 16px">{{ fullName }}</div>
        <div style="font-size: 13px">
          {{ "کد طلبگی: " + userInfo.Num_System }}
        </div>
        <div style="font-size: 13px">{{ "مدرسه " + userInfo.School }}</div>
        <div style="font-size: 13px">
          {{ userInfo.Sath + " - " + userInfo.Payeh }}
        </div>
        <div style="font-size: 13px">
          {{ userInfo.Talabbos + " - " + "شهریه " + userInfo.StrShahrieh }}
        </div>
      </template>
      <template v-else>
        <div style="font-size: 13px">
          {{ fullName }}
          <br />
        </div>
      </template>
    </div>
    <v-btn
      class="login-button"
      color="red white--text"
      @click="handleLogin"
      rounded
      >{{ buttonTitle }}</v-btn
    >
  </div>
</template>

<script>
import { getToken, logout } from "@/utils/auth";
import router from "@/router";
import { removeNotificationId } from "@/api/notification";
export default {
  computed: {
    fullName() {
      return this.$store.getters.FullName;
    },
    NumSystem() {
      var num = this.$store.getters.NumSystem;
      return num != "" ? "کد طلبگی:  " + num : "";
    },
    buttonTitle() {
      return this.$store.getters.token != "" ? "خروج" : "ورود";
    },
    ImageUrl() {
      if (this.$store.getters.ImageUrl != "") {
        return "url(" + this.$store.getters.ImageUrl + ")";
      } else return "../assets/avatar.jpg";
    },
    userActive() {
      return this.$store.getters.userInfo.Active;
    },
    userInfo() {
      return this.$store.getters.userInfo;
    },
  },
  methods: {
    /**
     * logout/ login
     */
    handleLogin() {
      logout();
    },
  },
};
</script>
<style>
.name {
  position: absolute;
  top: 60px;
  right: 100px;
  font-size: 15px;
}

.slide-header {
  display: block !important;
  /* background-image: url("../../assets/newback.png"); */

  padding: 5px 15px 50px 15px !important;
  color: white;
  height: 320px;
  width: 300px;
  position: sticky;
  top: 0px;
  z-index: 1;
}

.login-button {
  float: left;
  top: 70px;
  height: 32px !important;
  left: 20px;
}

/* .avatar {
  width: 70px;
  height: 84px;
  float: right;
  margin: 15px 0px;
  background-size: 100%;
  border-radius: 6px;
  cursor: pointer;
} */

.fullname {
  padding-bottom: 30px;
}

.avatarMobile {
  width: 90px;
  height: 90px;
  border-radius: 45px;
  background-size: cover;
  margin: auto;
  top: 3px;
  position: relative;
  background-position: 50%;
  cursor: pointer;
}

.avatarFrame {
  width: 100px;
  height: 100px;
  border-radius: 340px;
  margin: auto;
  top: 40px;
  position: relative;
  border: 3px dotted rgba(255, 255, 255, 0.6);
}

.nameMobile {
  color: white;
  text-align: center;
  font-size: 1em;
  top: 45px;
  position: relative;
}
</style>
